/* lm-collection — full-viewport slide carets. Clicking a down-caret cue smooth-scrolls to the next
   full-viewport block (the title hero counts as one); if there's no next block it nudges one viewport
   down (e.g. a section page's gallery below its hero). Idempotent; respects reduced-motion. */
(() => {
  if (window.__lmCollection) return;
  window.__lmCollection = true;

  const BLOCK = '.lm-slide, .lm-collection-hero';

  const onClick = (e) => {
    const cue = e.target.closest('[data-slide-cue]');
    if (!cue) return;
    e.preventDefault();
    const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    const blocks = [...document.querySelectorAll(BLOCK)];
    const cur = cue.closest(BLOCK);
    const next = blocks[blocks.indexOf(cur) + 1];
    if (next) next.scrollIntoView({ behavior, block: 'start' });
    else window.scrollBy({ top: window.innerHeight, behavior });
  };

  const init = () => {
    if (document.__lmCollectionWired) return;
    if (!document.querySelector(BLOCK)) return;
    document.__lmCollectionWired = true;
    document.addEventListener('click', onClick);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
